import SearchOption from 'eop-ui-core/models/SearchOption'
import repository from '@/api'
import { AUTH_API_URL } from '@/constants/env'

const URI = '/v1/auth-misc'
export default {
  findEmployeeNos({ name, birthDate, sex }, onError) {
    const queryString = new SearchOption({ condition: { name, birthDate, sex } }).toQueryString()
    return repository.get(`${URI}/find-employee-nos${queryString}`, { onError, baseURL: AUTH_API_URL.replace('pw', '_pw') })
  },
  recoverPassword({ smsPasscodeId, username, newPassword }) {
    return repository.put(
      `${URI}/recover-password`,
      { username, newPassword },
      { headers: { 'X-CNSAMC-SMS-PASSCODE-ID': smsPasscodeId }, baseURL: AUTH_API_URL.replace('pw', '_pw') },
    )
  },
  changePassword({ username, currentPassword, newPassword }) {
    return repository.put(`${URI}/change-password`, { username, currentPassword, newPassword }, { baseURL: AUTH_API_URL })
  },
}
